import React from 'react'
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

export interface CloudElement {
  id: number;
  elementType: string;
  elementId: string;
  vpcId: string;
  region: string;
  tags: string;
  discoveredAt: string;
  reflectorInstanceId: number;
  createdAt: string;
  updatedAt: string;
}

export interface Interface {
  id: number;
  interface: string;
  ipAddress: string;
  macAddress: string;
  type: string;
  vpcId: string;
  cloudSubnetId: string;
}

export interface Reflector {
  id: string;
  name: string;
  description: string;
  subId: string;
  status: string;
  availability?: number | null;
  cloud: string;
  region: string;
  cluster: string;
  clusterId?: string;
  version: string;
  lastSync: string;
  createdAt: string;
  vpcId: string;
  tags?: string[];
  data?: {
    ha?: string;
    cni?: Record<string, string>;
    cloud?: string;
    ha_ip?: string | null;
    region?: string;
    cloudSubnetId?: string;
  };
  cloudElements?: CloudElement[];
  interfaces?: Interface[];
  // ...other fields as needed
  license?: {
    id: number;
    serial: string;
    type: string;
    status: number;
    total: number;
    activated: number;
    available: number;
    startDate: string;
    endDate: string;
  };
}

const ReflectorIdCell = ({ row }: { row: Reflector }) => {
  const navigate = useNavigate();
  return (
    <button
      className="
        hover:text-semantic-text-brand 
        hover:underline
        focus:underline 
        active:underline
        font-medium
        underline
        text-semantic-text-brand
      "
      onClick={() => navigate(`/reflector-v2/management/bgp-reflectors/details/${row.id}`, { 
        state: { selectedReflectorRow: row } 
      })}
    >
      {row.name}
    </button>
  );
};

export const reflectorColumns: GenericTableColumn<Reflector>[] = [
  {
    header: "Reflector ID",
    accessor: "name",
    renderCell: (row) => <ReflectorIdCell row={row} />,
  },
  {
    header: "Name",
    accessor: "description",
    renderCell: (row) => row.description,
  },
  {
    header: "UUID",
    accessor: "subId",
    renderCell: (row) => row.subId || "-",
  },
  {
    header: "Status",
    accessor: "status",
    renderCell: (row) => {
      let variant: "success" | "warning" | "error" | "default" = "default";
      
      if (row.status === "Online") {
        variant = "success";
      } else if (row.status === "Offline") {
        variant = "error";
      }
      
      return (
        <GenericTag
          label={row.status}
          variant={variant}
          size="small"
          rounded="full"
        />
      );
    },
  },
  {
    header: "Cloud",
    accessor: "cloud",
    renderCell: (row) => (
      <GenericTag
        label={row.cloud}
        variant={row.cloud === "AWS" ? "warning" : row.cloud === "GCP" ? "success" : "neutral"}
        size="small"
        rounded="full"
      />
    ),
  },
  {
    header: "Region",
    accessor: "region",
    renderCell: (row) => (
      <GenericTag
        label={row.region}
        variant="neutral"
        size="small"
        rounded="full"
      />
    ),
  },
  {
    header: "Cluster",
    accessor: "cluster",
    renderCell: (row) => (
      <GenericTag
        label={row.cluster}
        variant="neutral"
        size="small"
        rounded="full"
      />
    ),
  },
  {
    header: "Version",
    accessor: "version",
  },
  {
    header: "Last Sync",
    accessor: "lastSync",
    renderCell: (row) => formatDateDMY(row.lastSync),
  },
  
];

export const TABS = ["Device View", "Cluster View"];

function formatDateDMY(dateString: string) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "-";
  return format(date, "dd/MM/yyyy");
}



